import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Sign = Loadable({
    loader: () => import('./Sign'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpAutoRechargeSignState: state.topUpAutoRechargeSignState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          submit,
          languageChange
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/sign/:token`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Sign {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
